<template>
  <v-card :loading="loading" class="block">
    <h1 v-if="title" class="title font-weight-light">{{ title }}</h1>
    <v-divider v-if="title" class="title-divider"></v-divider>
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: "BaseBlock",
  props: ["title", "loading"],
};
</script>

<style scoped>
.block {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 3px;
  padding: 1rem;
}

.title-divider {
  margin: 1rem -1rem;
  max-width: initial;
}
</style>
